import Styles from './Layout.module.scss';
const Sticky = ({ children, wrapperProps, ...props }) => {
  return (
    <div style={{ position: 'relative', ...wrapperProps }}>
      <div className={Styles.sticky} style={props}>
        {children}
      </div>
    </div>
  );
};
export default Sticky;
